import {Component, EventEmitter, inject, input, Output} from '@angular/core';
import {FaultyEcuBuildsService} from "../../../service/FaultyEcuBuilds.service";
import {FaultyEcuBuild} from '../../../models/FaultyEcuBuild';

@Component({
    selector: 'app-faulty-ecu-builds-table',
    templateUrl: './faulty-ecu-builds-table.component.html',
    styleUrl: './faulty-ecu-builds-table.component.css'
})
export class FaultyEcuBuildsTableComponent {

    faultyEcuBuildsService = inject(FaultyEcuBuildsService);
    @Output() faultyEcuBuild = new EventEmitter<string>();
    faultyEcuBuildList = input.required<FaultyEcuBuild[]>();
    selectedEcu = input<string | null>(null);

    getFaultyPureOriginalsByFaultyEcuBuild(ecuBuild: string) {
        this.faultyEcuBuild.emit(ecuBuild);
    }

}
